import { render } from "./404.vue?vue&type=template&id=53b955a4&scoped=true"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"

import "./404.vue?vue&type=style&index=0&id=53b955a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53b955a4"

export default script